import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { Envelope } from '../../interfaces/envelope';
import { Role } from '../../interfaces/types';
import { referenceService } from '../services/reference.service';

interface ReferenceState {
	roles: {
		[id: number]: Role;
	};
	isLoading: boolean;
}

const initialState = {
	roles: [],
	isLoading: false,
} as ReferenceState;

export const fetchReferenceRoles = createAsyncThunk<
	Role[],
	void,
	{
		rejectValue: Envelope<[]> | unknown;
	}
>('reference/fetchRoles', async (_undefined, { rejectWithValue }) => {
	try {
		return await referenceService.fetchRoles();
	} catch (error) {
		return rejectWithValue(error);
	}
});

const referenceSlice = createSlice({
	name: 'reference',
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addCase(fetchReferenceRoles.fulfilled, (state, action) => {
			const ret: { [id: number]: Role } = {};
			state.roles = action.payload.reduce((obj, role) => {
				obj[role.id] = role;
				return obj;
			}, ret);
			state.isLoading = false;
		});
		builder.addCase(fetchReferenceRoles.pending, (state) => {
			state.isLoading = true;
		});
		builder.addCase(fetchReferenceRoles.rejected, (state, action) => {
			state.roles = [];
			state.isLoading = false;
		});
	},
});

export default referenceSlice;
